import { acceptHMRUpdate, defineStore } from "pinia";

export const useTexteditor = defineStore("ui/textEditor", {
  state: () => ({
    handleId: null as null | string,
    value: null as null | string,
    onUpdate: null as null | ((val: string) => void),
    onClose: undefined as undefined | (() => void)
  }),
  actions: {
    open({
      handleId,
      value,
      onUpdate,
      onClose
    }: {
      handleId?: string,
      value: string;
      onUpdate: (val: string) => void;
      onClose?: () => void;
    }) {
      this.$patch((state) => {
        state.handleId = handleId ?? null;
        state.value = value;
        state.onUpdate = onUpdate;
        state.onClose = onClose;
      });
    },
    close() {
      if (this.onClose) this.onClose();
      this.$reset();
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTexteditor, import.meta.hot));
}
